


















import {Vue,Component, Ref} from 'vue-property-decorator'
import {namespace} from 'vuex-class';
import Toolbar from '@/components/beta/Toolbar.vue';
import FullDialog from '@/components/UI/FullDialog.vue';
import FullError from '@/components/UI/FullError.vue';
import FullPlan from "@/components/UI/FullPlan.vue";
// import ModalError from '@/components/UI/ModalError.vue';
import Sidebar from '@/components/common/widget/Sidebar.vue';
import ModalSupport from "@/components/UI/ModalSupport.vue";

const appStore = namespace('app')
const dialog = namespace('dialog')

@Component({
  components: {
    Toolbar,
    FullDialog,
    Sidebar,
    FullPlan,
    ModalSupport,
  }
})
export default class LfsLayout extends Vue {

  @appStore.Mutation('setScrollHeight') protected setScrollHeight: any
  @appStore.Getter('GetScrollHeight') protected GetScrollHeight:any
  @dialog.Getter('fullErrorShow') protected fullErrorShow: any

  @Ref('box') readonly box!:HTMLElement

  onScroll () {
    // const param:number = this.box.getBoundingClientRect().y
    // this.setScrollHeight(param)
  }

  protected mounted() {
    // window.addEventListener ('scroll', this.onScroll);
    // this.$store.dispatch('testing/load');
  }
}

